/*
  Pagina de produto (snippets/product-info.liquid): descricao longa mostra o comeco com "Ler descricao completa".
  Sem JavaScript, a descricao aparece inteira.
  (293a4120) Links com data-unend-abre-sanfona (ex.: "entenda os niveis" na ficha) abrem a sanfona apontada no href
  e rolam ate ela. Sem JavaScript, o link so rola ate a sanfona fechada.
*/
document.addEventListener('click', (evento) => {
  const link = evento.target.closest('[data-unend-abre-sanfona]');
  if (!link) return;
  const alvo = document.querySelector(link.getAttribute('href'));
  if (!alvo) return;
  evento.preventDefault();
  const sanfona = alvo.querySelector('details');
  if (sanfona) {
    sanfona.open = true;
    sanfona.setAttribute('aria-expanded', 'true');
  }
  alvo.scrollIntoView({ block: 'start', behavior: 'smooth' });
});

if (!window.customElements.get('unend-descricao')) {
  window.customElements.define(
    'unend-descricao',
    class extends HTMLElement {
      connectedCallback() {
        this.texto = this.querySelector('.unend-descricao__texto');
        this.botao = this.querySelector('.unend-descricao__mais');
        if (!this.texto || !this.botao) return;

        this.botao.addEventListener('click', () => this.alternar());
        this.texto.querySelectorAll('img').forEach((imagem) => {
          imagem.addEventListener('load', () => this.medir(), { once: true });
        });
        window.requestAnimationFrame(() => this.medir());
      }

      medir() {
        if (this.classList.contains('is-aberta')) return;
        const limite = parseFloat(getComputedStyle(this).getPropertyValue('--unend-descricao-altura')) || 260;
        const recortar = this.texto.scrollHeight > limite + 80;
        this.classList.toggle('is-recortada', recortar);
        this.botao.hidden = !recortar;
      }

      alternar() {
        const aberta = this.classList.toggle('is-aberta');
        this.botao.setAttribute('aria-expanded', String(aberta));
        const en = (document.documentElement.lang || '').toLowerCase().startsWith('en');
        this.botao.textContent = aberta ? (en ? 'Show less' : 'Mostrar menos') : (en ? 'Read full description' : 'Ler descrição completa');
        if (!aberta) this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  );
}
